import React from "react";
import PropTypes from "prop-types";

const ValidatedInput = ({ children, errors, className }) => (
  <div
    className={`form-group ${
      errors.length > 0 ? "has-error" : ""
    } ${className}`}
  >
    {children}
    {errors.length > 0 && (
      <span className="help-block help-block--validation">{errors[0]}</span>
    )}
  </div>
);

ValidatedInput.propTypes = {
  children: PropTypes.node,
  errors: PropTypes.arrayOf(PropTypes.string),
  className: PropTypes.string,
};

ValidatedInput.defaultProps = {
  children: null,
  errors: [],
  className: "",
};

export default ValidatedInput;
